import angular, { ILogService } from 'angular'

class EditorFormularComponentCtrl {
  // empresa!: string

  constructor(private $log: ILogService) {}

  $onInit(): void {
    this.$log.info('[EditorFormularComponentCtrl] onInit')
  }
}

angular.module('candidato').component('editorFormular', {
  bindings: {
    // empresa: "<",
  },
  controller: EditorFormularComponentCtrl,
  template: require('./editor-formular.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/editor-formular/editor-formular.component.html"
})
